import { render, staticRenderFns } from "./LS03.vue?vue&type=template&id=3fe7f4a6&scoped=true"
import script from "./LS03.vue?vue&type=script&lang=js"
export * from "./LS03.vue?vue&type=script&lang=js"
import style0 from "./LS03.vue?vue&type=style&index=0&id=3fe7f4a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7f4a6",
  null
  
)

export default component.exports